import DoNotLogError from './DoNotLogError'

/*
 * This function will return true IFF the caught errormessage contains any of the
 * error sub-strings listed below, or the error name matches any of the list. These are common errors that we can safely ignore
 * across all products.
 */

// these should all be lowercase
const errorSubStringsToIgnore = [
  'network error',
  'timeout',
  'bad gateway',
  'not authenticated',
  'no current user',
  'request failed with status code 401',
  'no time remaining',
  `unprocessable entity:422, {"message":"selected time slot no longer available"}`,
  'non-error exception captured with keys: code, message, name',
  'username/client id combination not found',
  'invalid verification code provided',
  'invalid code provided',
  'there is already a signed in user',
  'token refresh is not supported',
  'attempt limit exceeded',
]

// these are the error names that we can ignore (they are not lowercased, they must match exactly)
const errorNamesToIgnore = [
  'DoNotLogError',
  'LimitExceededException',
  'UserNotFoundException',
  'CodeMismatchException',
  'UserAlreadyAuthenticatedException',
  'NoSignedUser',
  'NetworkError',
  'TokenRefreshException',
  'ExpiredCodeException',
]

/**
 * @param {Error} error
 * @returns {boolean}
 */
export default function shouldIgnoreSentryError(error) {
  if (!error) {
    return false
  }

  if (error instanceof DoNotLogError) {
    return true
  }

  // the error name is the .name property of the error object (if it's an object with a name property)
  const errorName = typeof error === 'object' && error.name ? error.name : ''

  // the error message is the .message property of the error object (if it's an object with a message property), otherwise it's the error itself if it's a string
  const errorMessage = typeof error === 'object' && error.message ? error.message : typeof error === 'string' ? error : ''

  // if both are empty, we can ignore it
  if (!errorMessage.length && !errorName.length) {
    return false
  }

  // check name first
  if (errorNamesToIgnore.includes(errorName)) {
    return true
  }

  // now check message
  const lowerCaseErrorMessage = errorMessage.toLowerCase()
  return errorSubStringsToIgnore.some(subString => lowerCaseErrorMessage.includes(subString))
}
